export default {
  index: [
    {
      path: '/zkequitydetail',
      component: resolve => require(['./zkequitydetailIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkequitydetail/_router.js